import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteTotalFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='TOTAL' htmlFor='input-importeTotal' md={12} />
      <Col md={12}>
        <Form.InputNumber
          id='input-importeTotal'
          name='input-importeTotal'
          value={iValue}
          disabled
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteTotalFormGroup)
